import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { ActivatedRoute, Params, Router, NavigationStart, ActivatedRouteSnapshot, ParamMap } from '@angular/router';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalSelectSerialComponent } from 'src/app/components/ui/modal-select-serial/modal-select-serial.component';
import { DeviceService } from 'src/app/services/devices/device.service';
import { isRelaySchedulerDevice } from 'src/app/services/devices/device-type.util';
import { ModalService } from 'src/app/services/modal/modal.service';
import { UserService } from 'src/app/services/user/user.service';
import { Location } from '@angular/common';
import { catchError, concatMap, filter, map } from 'rxjs/operators';
import { Observable, of, Subscription, forkJoin } from 'rxjs';
import { Component, OnInit, OnDestroy, HostListener, Input } from '@angular/core';
import { DashboardService } from 'src/app/services/dashboard/dashboard.service';
import calculoZoom from 'src/app/pages/dashboard/calculoDistancias';




export interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}

interface TreeNode {
  name: string;
  alias?: string
  isExpanded?: boolean;
  children?: TreeNode[];
  devices?: any[];
  subgroups?: any[]
}

interface Devices {
  serial: string,
  role: string,
  name?: string,
  alive?: number
}


@Component({
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})

export class SidebarComponent implements OnInit {
  @Input() userRole: string = '';
  @Input() userEmail: string = '';
  @Input() userSubs: any[] = [];
  devices: any[] = [];
  deviceTypeFilter: 'all' | 'evvc' | 'lighting' = 'all';

  filteredSerial = '';
  filteredGroup = '';

  group: string | null = null;

  sidebarHeight: string = 'calc(100vh - 64px)'; // Altura inicial
  sidebarTop: string = '64px'; // Posición inicial desde la parte superior
  devicesHeight: string = '56vh';

  top : string = '';


  modalDiagnosis!: NgbModalRef;

  data: any[] = []
  modoDashboard: string = '';
  view : 'devices' | 'groups' = 'groups';
  activeAccordion: string | null = null; // Control del acordeón activo


  navStart: Observable<NavigationStart>;
  updateSidebar: any;

  paramInfoGroup: string | null | undefined= null; // Parámetro de ruta 'infoGroup'
  paramGroup: string | null | undefined = null; // Parámetro de ruta 'newGroup'
  paramSplGroup : string | null | undefined = null; // Parámetro de ruta 'slpGroup'
  paramViewGroup : string | null | undefined = null  // Parámetro de ruta 'viewGroup'
  paramDevice : string | null | undefined = null;
  selectedNode: any = null;
  expandedNode: any = null;

  expandedParentNode: TreeNode | null = null;
  expandedChildNode: TreeNode | null = null;
  expandedGrandchildNode: TreeNode | null = null;

  favoriteDevices: string[] = []
  owner : string = '';

  constructor(private _devices: DeviceService,
    private _router: Router,
    private _modal: ModalService,
    private _user: UserService,
    private rutaActiva: ActivatedRoute,
    private location: Location,
    private _dashboard: DashboardService) {

    // Create a new Observable that publishes only the NavigationStart event
    this.navStart = _router.events.pipe(
      filter(evt => evt instanceof NavigationStart)
    ) as Observable<NavigationStart>;
  }


  ngOnInit() {

    this._dashboard.getModoDashboard().subscribe(data => {
      this.modoDashboard = data
    });

    this._dashboard.getViewDashboard().subscribe( data => {
      this.view = data
    })

    this._dashboard.getUpdateSidebar().subscribe( data => {
      this.updateSidebar = data;
      if( this.updateSidebar == 1){
        this.expandedParentNode = null;
        this.expandedChildNode= null;
        this.expandedGrandchildNode = null;
        this.paramInfoGroup = null; // Parámetro de ruta 'infoGroup'
        this.paramGroup = null; // Parámetro de ruta 'newGroup'
        this.paramSplGroup = null; // Parámetro de ruta 'slpGroup'
        this.paramViewGroup = null  // Parámetro de ruta 'viewGroup'
        this.paramDevice = null
        this.selectedNode = null

        this.getGroups();
      }
    })


    // Obtener la URL completa incluyendo query parameters
    const currentUrl = this.location.path();
    this.extractParamsFromUrl(currentUrl);
    if (this.paramInfoGroup) {
      this.selectedNode = this.paramInfoGroup;
    }

    this.navStart.subscribe(evt => {
      //this.selectedNode = null;
      this.paramGroup=null , this.paramInfoGroup=null, this.paramSplGroup=null, this.paramViewGroup=null;  this.paramDevice=null;
      this.extractParamsFromUrl(evt.url)
    });

    this.getAllDevices();
    this.getGroups();

  }

  getAllDevices(){
    this._devices?.getDevices().subscribe((devices) => {
      console.log('devices ', devices);
      for (let device of devices) {
        if (isRelaySchedulerDevice(device)) {
          this._devices.getModuleInfo(device.serial, "channel").subscribe((data) => {
            console.log('data channel',data.stat);
            devices.find((d) => d.serial === device.serial).stat = data.stat;
          })
        }
      }
      this.devices = devices;
      console.log(this.devices);
      this.orderFavoriteDevices();
  })
}

  getGroups() {
    this.data = [];
    this._devices.getGroups('onlyParents').subscribe(async groupsParents => {
      if (groupsParents && groupsParents.length > 0) {
        this.data = groupsParents;

        /*await groupsParents.forEach(async group => {
          await this._devices.getGroup(group.alias).subscribe(data => {
            this.data.push(data);
          });
        });*/

        this.data.sort((a, b) => new Date(a.date_build).getTime() - new Date(b.date_build).getTime());
        this._dashboard.resetUpdateSidebar();

      } else {
        this._dashboard.resetUpdateSidebar();
      }

      if(this.selectedNode != null){
        this.toggleNode(this.data.find((group) => group.alias === this.selectedNode), [], this.data.findIndex((group) => group.alias === this.selectedNode), false);
      }
    });
  }



  extractParamsFromUrl(url: string) {
    const regex = /(group|newgroup|splconfig|viewgroup|device)\/([^\/]+)/;
    const match = url.match(regex);

    if (match) {
      const parameter = match[2];
      switch (match[1]) {
        case 'group':
          this.paramInfoGroup = parameter;
          break;
        case 'newgroup':
          this.paramGroup = parameter;
          break;
        case 'splconfig':
          this.paramSplGroup = parameter;
          break;
        case 'viewgroup':
          this.paramViewGroup = parameter;
          break;
        case 'device':
            this.paramDevice = parameter;
          break;
      }
    }
  }


  clickDiagnosis() {
    this.modalDiagnosis = this._modal.open(ModalSelectSerialComponent);
    this.modalDiagnosis.componentInstance.devices = this.devices;

    this.modalDiagnosis.result.then((result) => {
      if (result) {
        this._router.navigate(['/dashboard/diagnosis', result]);
      }
    });
  }

  clickDevice(device: any): void {
    this._devices?.setUserDevice(this.userEmail);
    this.selectedNode = null;
    setTimeout(() => {
      this._router.navigate(['/dashboard/device', device]);
    },500);
  }

  deleteUserDevice() {
    //var self = this;
    //self._devices.setUserDevice(null);
  }

  addGroup() {
    this._router.navigate(['/dashboard/newgroup']);
  }


  toggleNode(node: TreeNode, devices: any[], index: number, open: boolean = true) {
    if(!node)
      return;
    if (node?.isExpanded && !open) {
      node.isExpanded = false;
      this.expandedParentNode = null;
      if(!open)
        return;
    } else {
      node.isExpanded = true;
    }

    if(node.devices == undefined){
      this._devices.getGroup(node.alias).subscribe(data => {
        node.subgroups = data.subgroups || [];
        this.orderArraySubgruops(node.subgroups);
        node.devices = data.devices || [];
        this.orderArrayDevice(data.devices);
        if(open){
          this.openNode(node, data.devices);
        }
      });
    }
    else{
      if(open){
        this.openNode(node, devices);
      }
    }
  }

  openNode(node: TreeNode, devices: any[]){
    this.expandedParentNode = node;

    this._dashboard.resetBreadCrumbs();
    this._dashboard.setBreadCrumbs({ name: node.name, alias: node.alias == undefined ? "" : node.alias  });

    this.selectedNode = node.alias ;
    this.navigate(node.alias ?? '', devices);
  }


  clickGroup(parentNode: TreeNode, child: TreeNode, open: boolean = true) {
    // Expandir/contraer subgrupo
    if (child?.isExpanded && !open) {
      child.isExpanded = false;
      this.expandedChildNode = null;
    } else {
      child.isExpanded = true;
    }

    if(child.devices == undefined){
      this._devices.getGroup(child.alias).subscribe(data => {
        child.children = data.subgroups || [];
        this.orderArraySubgruops(child.children);
        child.devices = data.devices || [];
        this.orderArrayDevice(child.devices);

        if(open){
          this.openChild(child, parentNode, data.devices);
        }
      });
    }
    else{
      if(open){
        this.openChild(child, parentNode, child.devices);
      }
    }
  }

  openChild(child: TreeNode, parent: TreeNode, devices: any[]){
    this.expandedParentNode = parent;
    this.expandedChildNode = child;

    // Gestionar breadcrumbs
    const breadcrumbs = [
      { name: 'home', alias: 'dashboard' },
      { name: parent.name, alias: parent.alias ?? '' },
      { name: child.name, alias: child.alias ?? '' }
    ];
    this._dashboard.replaceBreadCrumbs(breadcrumbs);

    this.selectedNode = child.alias ;
    this.navigate(child.alias ?? '', devices);
  }

  clickGrandchild(parentNode: TreeNode, child: TreeNode, grandchild: TreeNode, open: boolean = true) {
    // Expandir/contraer subgrupo
    if (grandchild?.isExpanded && !open) {
      grandchild.isExpanded = false;
      this.expandedChildNode = null;
    } else {
      grandchild.isExpanded = true;
    }

    if(grandchild.devices == undefined){
      this._devices.getGroup(grandchild.alias).subscribe(data => {
        grandchild.children = data.subgroups || [];
        this.orderArraySubgruops(grandchild.children);
        grandchild.devices = data.devices || [];
        this.orderArrayDevice(grandchild.devices);

        if(open){
          this.openGrandChild(grandchild, child, parentNode, data.devices);
        }
      });
    }
    else{
      if(open){
        this.openGrandChild(grandchild, child, parentNode, grandchild.devices);
      }
    }
  }

  openGrandChild(grandChild: TreeNode, child: TreeNode, parent: TreeNode, devices: any[]){
    this.expandedParentNode = parent;
    this.expandedChildNode = child;
    this.expandedGrandchildNode = grandChild;

    // Gestionar breadcrumbs
    const breadcrumbs = [
      { name: 'home', alias: 'dashboard' },
      { name: parent.name, alias: parent.alias ?? '' },
      { name: child.name, alias: child.alias ?? '' },
      { name: grandChild.name, alias: grandChild.alias ?? '' }
    ];

    this._dashboard.replaceBreadCrumbs(breadcrumbs);

    this.selectedNode = grandChild.alias ;
    this.navigate(grandChild.alias ?? '', devices);
  }



  navigate(param , devices ){
    var currentUrl = this._router.url;

    if(this.modoDashboard == 'map' && currentUrl == "/dashboard"){
        this._router.navigate([`/dashboard/group/${param}/map`]);
        this.loadGeolocationAndNavigate(devices, param);
    }
    else {

      const lastSegment = currentUrl.split('/').filter(Boolean).pop();
        if (lastSegment === 'map') {
          this.loadGeolocationAndNavigate(devices, param);
          this.paramInfoGroup = null
          this._router.navigate([`/dashboard/group/${param}/map`]);
        }else{
          if( this.paramInfoGroup != null){
            this._router.navigate([`/dashboard/group/${param}`]);
          }
          if( this.paramViewGroup != null){
            this._router.navigate([`/dashboard/viewgroup/${param}`]);
          }
          if( this.paramGroup != null){
            this._router.navigate([`/dashboard/newgroup/${param}`]);
          }
          if( this.paramSplGroup != null){
            this._router.navigate([`/dashboard/splconfig/${param}`]);
          }
          if( this.paramInfoGroup == null && this.paramViewGroup == null && this.paramGroup == null && this.paramSplGroup == null ){
            this._router.navigate([`/dashboard/group/${param}`]);
          }
        }
    }
  }
  loadGeolocationAndNavigate(devices: any[] | undefined, alias: string | undefined) {
    if (!devices || devices.length === 0) return;

    var geolocation = devices
      .filter(device => device.coords != null)
      .map(device => {
        const geoloc = JSON.parse(device.coords);
        return {
          position: {
            lat: parseFloat(geoloc[0]),
            lng: parseFloat(geoloc[1])
          }
        };
      });

    if (geolocation.length > 0) {
      this._dashboard.setLocation(geolocation[0].position);
      this._dashboard.setZoom(calculoZoom(geolocation));
    }

  }

  changeView(selectedView: 'devices' | 'groups') {
    if (this.view !== selectedView) { // Solo cambia si es diferente
      if (this.userRole === 'admin' || this.hasGroupSubscription()) {
        this.view = selectedView;
      } else {
        this.view = 'devices';
      }
      this._dashboard.setViewDashboard(this.view);
    }
  }


  @HostListener('window:scroll', [])
  onWindowScroll() {
    // Calcula siha llegado al final de la página
    const windowHeight = window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;
    const scrollPosition = window.scrollY + windowHeight;


    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (scrollTop > 0) {
      this.sidebarHeight = '100vh'; // Cambiar a altura completa
      this.sidebarTop = '0'; // Cambiar para que empiece desde la parte superior
      this.devicesHeight = '62vh'
    } else {
      this.sidebarHeight = 'calc(100vh - 64px)'; // Altura inicial sin scroll
      this.sidebarTop = '64px'; // Posición inicial
      this.devicesHeight = '56vh'
    }

    if (scrollPosition >= pageHeight) {
      this.sidebarHeight = 'calc(100vh - 40px)'; // Altura inicial sin scroll
      this.devicesHeight = '58vh'
    }
  }

  home(){
    this._dashboard.setUpdateSidebar();
  }

  toggleAccordion(accordionName: string): void {
    if (this.activeAccordion === accordionName) {
      this.activeAccordion = null;
    } else {
      this.activeAccordion = accordionName;
    }
  }

  hasGroupSubscription(): boolean {
    return this._user.hasGroupsSubscription();
  }

  orderArrayDevice(array: any[] | undefined) {
    if (!array) return;
    array = array.sort((a, b) => {
      if(a.name){
        if(b.name){
          return a.name.localeCompare(b.name);
        }
        return a.name.localeCompare(b.serial);
      }
      else{
        if(b.name){
          return a.serial.localeCompare(b.name);
        }
        return a.serial.localeCompare(b.serial);
      }
    });
  }

  orderArraySubgruops(array: any[] | undefined) {
    if (!array) return;
    array = array.sort((a, b) => a.name.localeCompare(b.name));
  }

  trackByFn(index: number, item: any): any {
    return item.alias; // Usa un identificador único si existe
  }


  toogleFavoriteDevice(serial: string, isFavorite: boolean) {
    this._devices.setDeviceFavorite( serial, !isFavorite).subscribe( () => {
        this.devices.filter( device => device.serial == serial)[0].favorite = !isFavorite;
        this.orderFavoriteDevices();
      })
  }

  orderFavoriteDevices() {
    this.devices.sort((a, b) => {
      const aFav = a.favorite == true;
      const bFav = b.favorite == true;
      if (aFav !== bFav) {
        return aFav ? -1 : 1; // Favoritos primero
      }
      // Si ambos son favoritos o ninguno, ordenar alfabéticamente
      const aName = a.name || a.serial;
      const bName = b.name || b.serial;
      return aName.localeCompare(bName);
    });
  }

  setDeviceTypeFilter(type: 'all' | 'evvc' | 'lighting'): void {
    this.deviceTypeFilter = type;
  }

  isDeviceTypeVisible(device: any): boolean {
    if (this.deviceTypeFilter === 'all') return true;
    const isEvvc = String(device?.serial ?? '').includes('EVVC');
    if (this.deviceTypeFilter === 'evvc') return isEvvc;
    return !isEvvc;
  }

  countDevicesByType(type: 'all' | 'evvc' | 'lighting'): number {
    const devices = this.devices || [];
    if (type === 'all') return devices.length;
    if (type === 'evvc') return devices.filter((device: any) => String(device?.serial ?? '').includes('EVVC')).length;
    return devices.filter((device: any) => !String(device?.serial ?? '').includes('EVVC')).length;
  }

  checkOut(serial : string): boolean {
    const device = this.devices.find(item => item.serial == serial);
    if (!device) return false;

    const c1stat = Number(device?.stat?.c1stat);
    const c2stat = Number(device?.stat?.c2stat);
    return [2, 3].includes(c1stat) || [2, 3].includes(c2stat);

  }

}
